import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Briefcase, Bell, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../utils/i18n';
import './BottomNav.css';

const BottomNav = () => {
  const { language } = useAuth();
  const { t } = useTranslation(language);

  const navItems = [
    {
      path: '/',
      icon: Home,
      label: t('home'),
    },
    {
      path: '/work',
      icon: Briefcase,
      label: t('work'),
    },
    {
      path: '/notifications',
      icon: Bell,
      label: t('notifications'),
    },
    {
      path: '/profile',
      icon: User,
      label: t('profile'),
    },
  ];

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-container">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `bottom-nav-item ${isActive ? 'active' : ''}`
            }
            end={item.path === '/'}
          >
            <item.icon size={24} />
            <span className="bottom-nav-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
